import { all, takeEvery, call, put } from "redux-saga/effects";
import {
  list,
  create,
  detail,
  update,
  remove,
  changeIndex,
  updateGridsLayout,
} from "services/apis/widget";
import actions from "./actions";
import * as _ from "lodash";
import { toastr } from "react-redux-toastr";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* LIST({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
      error: false,
      fetched: false,
    },
  });

  const response = yield call(list, payload);
  if (response) {
    const meta = _.omit(response, "items");
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        list: response.items,
        meta,
        fetched: true,
      },
    });
  }

  if (!response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        error: true,
        fetched: false,
      },
    });
  }
}

export function* CREATE({ payload }) {
  const { body, filter } = payload;
  yield loading(true);

  const response = yield call(create, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: actions.LIST, payload: filter });
    toastr.success("create succeeded", "created new widget!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DETAIL({ payload }) {
  const { id } = payload;
  yield loading(true);

  const response = yield call(detail, id);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* UPDATE({ payload }) {
  const { id, body, filter } = payload;
  yield loading(true);

  const response = yield call(update, id, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: actions.LIST, payload: filter });
    toastr.success("update succeeded", "widget updated!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DELETE({ payload }) {
  const { id, filter } = payload;
  yield loading(true);

  let newFilter = filter;

  if (payload.totalItems) {
    const { totalItems } = payload;
    const { page, pageSize } = filter;
    let newPage = page;

    if (totalItems % pageSize <= 1 && page !== 1) {
      newPage -= 1;
    }
    newFilter = { ...filter, page: newPage };
  }

  const response = yield call(remove, id);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: actions.LIST, payload: newFilter });
    toastr.success("delete succeeded", "successfully deleted widget!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* CHANGE_INDEX({ payload }) {
  const { body, filter } = payload;
  yield loading(true);

  const response = yield call(changeIndex, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: actions.LIST, payload: filter });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* UPDATE_GRIDS_LAYOUT({ payload }) {
  const { body, filter } = payload;
  yield loading(true);

  const response = yield call(updateGridsLayout, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: actions.LIST, payload: filter });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LIST, LIST),
    takeEvery(actions.CREATE, CREATE),
    takeEvery(actions.DETAIL, DETAIL),
    takeEvery(actions.UPDATE, UPDATE),
    takeEvery(actions.DELETE, DELETE),
    takeEvery(actions.CHANGE_INDEX, CHANGE_INDEX),
    takeEvery(actions.UPDATE_GRIDS_LAYOUT, UPDATE_GRIDS_LAYOUT),
  ]);
}
